$( document ).on( 'ready', function() {
	$( '.click-to-copy' ).each( function() {
		var $item = $( this );
		$item.on( 'click', function( e ) {
			$item.removeClass( 'copied' );
			var textArea = document.createElement( 'textarea' );
			textArea.value = $item.text();
			textArea.style.position = 'absolute';
			textArea.style.left = '-9999px';
			e.target.appendChild( textArea );
			textArea.focus();
			textArea.select();
			document.execCommand( 'copy' );
			textArea.remove();
			$item.addClass( 'copied' );

			setTimeout( function() {
				$item.removeClass( 'copied' );
			}, 800 );
		} );
	} );
} );